import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import camelCase from "lodash/camelCase";

import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import SwitchButton from "components/SwitchButton";
import { MUTE_INSIGHT_TYPES } from "consts/insightTypes";

import EntitySnippet from "./EntitySnippet";
import MuteButton from "./MuteButton";
import ProfileSnippet from "./ProfileSnippet";
import useMuteSettings from "./useMuteSettings";

const MuteSettings = () => {
  const {
    mutedAccounts,
    mutedEntities,
    mutedCompanies,
    deleteMutedItem,
    updateMuteContents,
    settings,
    onMuteClick,
  } = useMuteSettings();

  return (
    <>
      <div className="flex flex-col md:flex-row md:space-y-0">
        <div className="w-[220px] mr-20px text-[18px] font-medium">
          Muted Research Types
        </div>
        <div className="space-y-[10px]">
          {MUTE_INSIGHT_TYPES?.map((i) => {
            const muted = settings?.[camelCase(i.key)];
            return (
              <div key={i.key} className="flex">
                <h3 className="text-[15px] leading-[30px] m-0 w-[300px]">
                  <OverlayTrigger
                    placement="top-start"
                    overlay={
                      <Tooltip className="[&>.tooltip-inner]:max-w-none">
                        {i.description}
                      </Tooltip>
                    }
                  >
                    <span className="">{i.name}</span>
                  </OverlayTrigger>
                </h3>
                <SwitchButton
                  checked={muted}
                  onClick={() => {
                    updateMuteContents(i.key);
                  }}
                  tooltip={muted ? "Click to unmute" : "Click to mute"}
                />
              </div>
            );
          })}
        </div>
      </div>
      <div className="flex flex-col md:flex-row md:space-y-0">
        <div className="w-[220px] mr-20px text-[18px] font-medium">
          Muted Insight Providers
        </div>
        <div className="pt-[3px]">
          {mutedAccounts?.length === 0 && mutedCompanies?.length === 0 && (
            <div>No muted insight providers</div>
          )}
          {mutedAccounts && mutedCompanies ? (
            <>
              {mutedAccounts?.map?.((i: any) => (
                <ProfileSnippet
                  key={i.id}
                  id={i.id}
                  name={i.mutedAccount?.name}
                  slug={i.mutedAccount.slug}
                  title={i.mutedAccount.title}
                  avatarUrl={i.mutedAccount.avatarUrl?.small}
                >
                  <MuteButton
                    onClick={() =>
                      i?.isDeleted
                        ? onMuteClick("account", "accounts", i.mutedAccount)
                        : deleteMutedItem(i)
                    }
                    muted={!i?.isDeleted}
                  />
                </ProfileSnippet>
              ))}
              {mutedCompanies?.map?.((i: any) => (
                <ProfileSnippet
                  key={i.id}
                  id={i.id}
                  name={i.mutedCompany?.name}
                  slug={i.mutedCompany.slug}
                  title={i.mutedCompany.title}
                  avatarUrl={i.mutedCompany.avatarUrl?.small}
                  type={"company"}
                >
                  <MuteButton
                    onClick={() =>
                      i?.isDeleted
                        ? onMuteClick("company", "companies", i.mutedCompany)
                        : deleteMutedItem(i)
                    }
                    muted={!i?.isDeleted}
                  />
                </ProfileSnippet>
              ))}
            </>
          ) : (
            <FontAwesomeIcon icon={faSpinner} spin className="mr-[5px]" />
          )}
        </div>
      </div>
      <div className="flex flex-col md:flex-row md:space-y-0">
        <div className="w-[220px] mr-20px text-[18px] font-medium">
          Muted Entities
        </div>
        <div className="pt-[3px]">
          {mutedEntities?.length === 0 && <div>No muted entites</div>}
          {mutedEntities ? (
            mutedEntities?.map?.((i: any) => (
              <EntitySnippet
                name={i.mutedEntity?.prettyName}
                slug={i.mutedEntity?.slug}
                id={i.id}
                logoUrl={i.mutedEntity.logoUrl?.small}
                key={i.id}
              >
                <MuteButton
                  onClick={() =>
                    i?.isDeleted
                      ? onMuteClick("entity", "entities", i.mutedEntity)
                      : deleteMutedItem(i)
                  }
                  muted={!i?.isDeleted}
                />
              </EntitySnippet>
            ))
          ) : (
            <FontAwesomeIcon icon={faSpinner} spin className="mr-[5px]" />
          )}
        </div>
      </div>
    </>
  );
};

export default MuteSettings;
